import { render, staticRenderFns } from "./Funcionario.vue?vue&type=template&id=ab04f192&"
import script from "./Funcionario.vue?vue&type=script&lang=js&"
export * from "./Funcionario.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports